/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ShopIcon = ({ width = 24, height = 24, hidden = false, title = 'Shop' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M34.94 16H1.06a.8.8 0 0 1-.769-1.02L3.793 2.725A1 1 0 0 1 4.754 2h26.492a1 1 0 0 1 .961.725L35.71 14.98a.8.8 0 0 1-.77 1.02ZM30 18v6H14v-6h-2v14H6V18H4v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V18ZM4 14h2L8 4H6Zm8.5 0h2l1-10h-2Zm8-10 1 10h2l-1-10ZM30 4h-2l2 10h2Z"
    />
  </svg>`;
};
